import React from 'react'
import c02 from "../../images/C02.png"
function Overlaycard() {
    const handleHide = () => {
        const overlayCard = document.querySelector('.fixed');
        if (overlayCard) {
            overlayCard.style.display = 'none';
        }
    };
  return (
    <div className='fixed flex bottom-24 right-4 z-50 cursor-pointer  bg-white h-[158px] rounded-[12px] p-5 w-[541px] gap-5 shadow-[#64646F33] shadow-xl'>
        
        <img src={c02} alt="CO2" />
        <div className='flex gap-5 ml-4'>
        <div>
            <div className='font-semibold text-[20px] text-[#3B3B3B] w-[325px]'>
           Advertise on CloseCarbon - Expand your reach
            </div>
            <div className='text-[#898989] text-[16px]'>
              Reach a targeted audience and grow your visibility across our platform.
            </div>
            <div className='flex gap-2 mt-2 text-[#006633] text-[18px]'    onClick={(e) => {
              e.preventDefault();
              document.getElementById('plans')?.scrollIntoView({ behavior: 'smooth' });
            }}>
                <div      
              >
 Advertise With Us
            </div>
            <div>
                               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.47 6.47007C12.6106 6.32962 12.8012 6.25073 13 6.25073C13.1988 6.25073 13.3894 6.32962 13.53 6.47007L18.53 11.4701C18.6705 11.6107 18.7493 11.8013 18.7493 12.0001C18.7493 12.1988 18.6705 12.3894 18.53 12.5301L13.53 17.5301C13.4613 17.6038 13.3785 17.6629 13.2865 17.7039C13.1945 17.7448 13.0952 17.7669 12.9945 17.7687C12.8938 17.7704 12.7938 17.7519 12.7004 17.7142C12.607 17.6765 12.5222 17.6203 12.451 17.5491C12.3797 17.4779 12.3236 17.3931 12.2859 17.2997C12.2482 17.2063 12.2296 17.1063 12.2314 17.0056C12.2332 16.9048 12.2552 16.8055 12.2962 16.7135C12.3372 16.6215 12.3963 16.5387 12.47 16.4701L16.19 12.7501H6C5.80109 12.7501 5.61032 12.6711 5.46967 12.5304C5.32902 12.3898 5.25 12.199 5.25 12.0001C5.25 11.8012 5.32902 11.6104 5.46967 11.4697C5.61032 11.3291 5.80109 11.2501 6 11.2501H16.19L12.47 7.53007C12.3295 7.38945 12.2507 7.19882 12.2507 7.00007C12.2507 6.80132 12.3295 6.6107 12.47 6.47007Z" fill="#006633"/>
</svg>

            </div>


            </div>
        </div>

        <div onClick={handleHide} >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#F5F5F5"/>
<path d="M16.2824 7.71509L7.71094 16.2865M16.2824 16.2865L7.71094 7.71509" stroke="black" stroke-width="1.07143" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

        </div>
        </div>
    </div>
  )
}

export default Overlaycard